import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="main-footer py-4 bg-white shadow-sm">
      <div className="container">
        <strong>
          Copyright &copy; {currentYear}{' '}
          <a href="/">vcurd</a>.
        </strong>{' '}
        All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
